import { KiteIcon } from '@kite/react-kite';
import React from 'react';
import { SmartLink } from '../SmartLink/SmartLink';
import './DataCard.scss';

export interface DataCardProps {
    title: string;
    value: string;
    showArrow?: boolean;
    footnoteIndex?: string;
    embeddedCS?: boolean;
}

export const DataCard = (props: DataCardProps) => {
    return (
        <li className="data-card">
            <p className={props.showArrow ? `has-arrow` : ``}>
                <span>{props.value}</span>
                {props.showArrow && <KiteIcon icon="ki-arrow-up" />}
            </p>
            <p className="caption">
                {props.title}
                {props.embeddedCS && props.footnoteIndex && (
                    <SmartLink href={`#article-sources-${props.footnoteIndex}`}>
                        <sup className="pointer-exempt">
                            {props.footnoteIndex}
                        </sup>
                    </SmartLink>
                )}
            </p>
        </li>
    );
};
